module.exports = __webpack_public_path__ + "img/computer.dbf1ea0b.svg";